import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import mapProps from 'map-props';

import CarMagnifierIcon from 'components/icons/CarMagnifierIcon.com.svg';

import propsMapping from './propsMapping';
import cn from './styles.local.less';

class NoResultsBlock extends PureComponent {
  static propTypes = {
    isUnpublished: PropTypes.bool,
    similarResultsMarkup: PropTypes.object,
  };

  renderNoResults() {
    return <p className={cn.text}>{__('search.noVehicleFound')}</p>;
  }

  renderUnpublished() {
    const { similarResultsMarkup } = this.props;

    return (
      <p className={cn.text}>
        <span>{__('search.vehicleNotAvailable')}</span>
        <br />
        <span dangerouslySetInnerHTML={similarResultsMarkup} />
      </p>
    );
  }

  render() {
    const { isUnpublished } = this.props;

    return (
      <section className={cn.root}>
        <div className={cn.iconContainer}>
          <CarMagnifierIcon className={cn.icon} />
        </div>
        {isUnpublished ? this.renderUnpublished() : this.renderNoResults()}
      </section>
    );
  }
}

export default mapProps(propsMapping)(NoResultsBlock);
